<template>
	<errorContainer :error="erreur" :warning="warning">
		<transition name="slide">
			<div :class="$screen.width > 576 ? 'container-layout' : 'container-mobile'">
				<div class="form">
					<b-row>
						<b-col md="12">
							<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">{{ FormMSG(130, 'Documents') }}</h1>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col class="p-0">
							<b-card class="pt-0 pr-0 pl-0" no-body>
								<b-card-text>
									<div>
										<b-tabs
											v-model="tabs.activeTabs"
											content-class="custom-content-tabs"
											nav-class="custom-nav-tabs"
											nav-wrapper-class="custom-nav-wrapper"
											@activate-tab="(n, p, e) => onTabClicked(n)"
										>
											<b-tab v-if="canSeeDocument && useDoc" :title="FormMSG(189, 'Documents')">
												<div>
													<b-row>
														<b-col sm="12" md="6" lg="6" xl="6">
															<b-input-group v-if="$screen.width >= 992">
																<b-form-input type="text" v-model="filter" :placeholder="FormMSG(31, 'Type to Search')" />
																<b-input-group-append class="cursor-pointer">
																	<b-input-group-text class="btn-search">
																		<Search
																			color="#FFFFFF"
																			:size="16"
																			class="icon"
																			:stroke-width="2.5"
																			v-if="filter.length === 0"
																		/>
																		<X
																			color="#FFFFFF"
																			:size="16"
																			class="icon"
																			:stroke-width="2.5"
																			@click="filter = ''"
																			v-else
																		/>
																	</b-input-group-text>
																</b-input-group-append>
															</b-input-group>
														</b-col>
														<b-col sm="12" md="3" lg="3" xl="3" class="pt-1">
															<b-form-checkbox
																size="lg"
																:value="true"
																@change="handleChangeShowArchivedDocument"
																:unchecked-value="false"
																class="pj-cb pb-1"
															>
																<div style="margin-top: 2px">{{ FormMSG(122, 'Show archived package') }}</div>
															</b-form-checkbox>
														</b-col>
														<b-col sm="12" md="3" lg="3" xl="3">
															<b-button
																variant="primary"
																block
																@click="createDocument()"
																class="w-200-px d-flex justify-content-center align-items-center pull-right"
															>
																<component :is="getLucideIcon('Plus')" :size="18" :stroke-width="2.5" />
																<div class="px-2">{{ FormMSG(17, 'New document') }}</div>
															</b-button>
														</b-col>
													</b-row>
													<b-row class="mt-3">
														<b-col cols="12" xl="12">
															<b-overlay :show.sync="isBusyDataTable" rounded="lg" class="w-100">
																<CardListBuilder v-if="$screen.width < 992" :items="docs" :fields="docfields">
																	<!-- @row-clicked="rowClicked" -->
																	<template slot="actions" slot-scope="data">
																		<b-button
																			variant="primary"
																			size="sm"
																			@click="rowClicked(data.item)"
																			title="Update document"
																			class="btn bg-transparent border-0"
																		>
																			<component
																				:is="getLucideIcon(ICONS.EDIT.name)"
																				:color="ICONS.EDIT.color"
																				:size="20"
																			/>
																		</b-button>
																		<b-button
																			variant="primary"
																			size="sm"
																			v-if="data.item.fileName.length > 0"
																			@click="viewDocument(data.item)"
																			title="View document"
																			class="btn bg-transparent border-0"
																		>
																			<component :is="getLucideIcon(ICONS.EYE.name)" color="#225CBD" :size="20" />
																		</b-button>
																		<b-button
																			class="btn bg-transparent border-0"
																			variant="danger"
																			size="sm"
																			v-if="showBtnTrashByStatus(data)"
																			@click="delItem(data.item.id)"
																			title="Delete document"
																		>
																			<component
																				:is="getLucideIcon(ICONS.TRASH.name)"
																				:color="ICONS.TRASH.color"
																				:size="20"
																			/>
																		</b-button>
																	</template>
																</CardListBuilder>
																<b-table
																	v-if="$screen.width >= 992"
																	:hover="hover"
																	responsive="sm"
																	sticky-header="900px"
																	ref="myTable"
																	selectable
																	:selectedVariant="selectedColor"
																	:select-mode="selectMode"
																	:items="docs"
																	style="text-align: left"
																	:fields="docfields"
																	:current-page="currentPage"
																	:filter="filter"
																	:per-page="perPage"
																	@row-clicked="rowClicked"
																	bordered
																	small
																	show-empty
																	:empty-text="FormMSG(264, 'No document found')"
																	:head-variant="hv"
																>
																	<template v-slot:cell(view)="data">
																		<b-button
																			variant="primary"
																			size="sm"
																			v-if="data.item.fileName.length > 0 || data.item.childDocList.length > 0"
																			@click="viewDocument(data.item)"
																			class="btn bg-transparent border-0"
																		>
																			<component
																				:is="getLucideIcon(ICONS.EYE.name)"
																				:color="ICONS.EYE.color"
																				:size="20"
																			/>
																		</b-button>
																	</template>
																	<!-- <template slot="rem" slot-scope="data"> -->
																	<template v-slot:cell(rem)="data">
																		<b-button
																			variant="danger"
																			size="sm"
																			v-if="showBtnTrashByStatus(data)"
																			@click="delItem(data.item.id)"
																			class="btn bg-transparent border-0"
																		>
																			<component
																				:is="getLucideIcon(ICONS.TRASH.name)"
																				:color="ICONS.TRASH.color"
																				:size="20"
																			/>
																		</b-button>
																	</template>
																</b-table>
															</b-overlay>
														</b-col>
													</b-row>
													<loading :active.sync="isLoading" :is-full-page="true" color="#00A09C"></loading>
													<b-modal
														:title="FormMSG(27, 'Success!')"
														class="modal-success"
														v-model="successModal"
														@ok="successModal = false"
														ok-variant="success"
														ok-only
													>
														{{ this.FormMSG(28, 'The new document has been saved.') }}
													</b-modal>
													<b-modal
														header-class="header-class-modal-doc-package"
														header-bg-variant="warning"
														title="Warning"
														class="modal-warning"
														v-model="documentWarningModal"
														@ok="documentWarningModal = false"
														ok-variant="warning"
														ok-only
													>
														{{ documentWarningMessage }}
													</b-modal>
													<b-modal
														header-class="header-class-modal-doc-package"
														:title="FormMSG(27, 'Success!')"
														class="modal-success"
														v-model="successModalDelete"
														@ok="successModalDelete = false"
														ok-variant="success"
														ok-only
													>
														{{ FormMSG(29, 'Your document has been deleted.') }}
													</b-modal>
												</div>
											</b-tab>
											<b-tab v-if="canSeeDocument && useDoc" lazy :title="FormMSG(190, 'Document package')" :active="activeTabDocPackage">
												<div>
													<table-hierarchical-doc-package />
												</div>
											</b-tab>
										</b-tabs>
									</div>
								</b-card-text>
							</b-card>
						</b-col>
					</b-row>
				</div>
			</div>
		</transition>
	</errorContainer>
</template>

<script>
import { isNil } from '@/shared/utils';
// import gql from 'graphql-tag';
import { store } from '@/store/index';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import { getFileExtension } from '@/shared/helpers';
import languageMessages from '@/mixins/languageMessages';
import { getDocumentList, newDocument, deleteDocument } from '@/modules/document-package/cruds/document.crud';
import TableHierarchicalDocPackage from '@/modules/document-package/components/TableHierarchicalDocPackage';
import { Search, X } from 'lucide-vue';
import globalMixin from '@/mixins/global.mixin';
import activeTabMixin from '@/mixins/activeTab.mixin';
import { DOCUMENT_DELIVERY_STATUS } from '@/shared/constants';

export default {
	name: 'Documents',
	components: { Loading, TableHierarchicalDocPackage, Search, X },
	mixins: [languageMessages, globalMixin, activeTabMixin],
	props: {
		hover: {
			type: Boolean,
			default: true
		},
		striped: {
			type: Boolean,
			default: true
		},
		bordered: {
			type: Boolean,
			default: true
		},
		small: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			hv: 'dark',
			erreur: {},
			formDataObj: {},
			docs: [],
			curDoc: {},
			newDoc: {},
			currentPage: 1,
			currentIdx: 0,
			perPage: 0,
			warning: '',
			filter: '',
			isLoading: false,
			pdfFile: null,
			wmImageFile: null,
			newCreated: 0,
			displayAllCategories: false,
			stopPropagation: '',
			nativeEvent: '',
			selectMode: 'single',
			selectedColor: 'primary',
			successModal: false,
			successModalDelete: false,
			documentWarningModal: false,
			documentWarningMessage: '',
			firstTime: true,
			lastPublishedOn: '',
			hideArchived: false,
			activeTabDocPackage: false,
			tabsValue: 0,
			isBusyDataTable: false,
			isCreated: false
		};
	},
	watch: {
		'$route.query': {
			handler() {
				setTimeout(() => {
					if (this.$route.query.tabs) {
						this.handleTabsQuery();
					} else {
						this.tabs.activeTabs = 0;
					}
				}, 300);
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		useDoc() {
			const storedProjectConfig = store.getCurrentProjectConfig();
			return storedProjectConfig ? storedProjectConfig.useDocument : false;
		},
		canSeeDocument() {
			return store.canManageDocuments();
		},
		optionsForDocType() {
			return this.FormMenu(1011);
		},
		docfields() {
			return [
				{
					key: 'name',
					label: this.FormMSG(50, 'Name'),
					sortable: true
				},
				{
					key: 'type',
					label: this.FormMSG(51, 'Type'),
					formatter: (value) => {
						return this.GetTextFromMenuNumberAndMenuValue(1011, value);
					},
					sortable: true
				},
				{
					key: 'fileName',
					label: this.FormMSG(52, 'File name'),
					sortable: true
				},
				{
					key: 'fullName',
					label: this.FormMSG(53, 'Publisher'),
					sortable: true
				},
				{
					key: 'createdAt',
					label: this.FormMSG(54, 'Date'),
					sortable: true,
					formatter: (value) => {
						return new moment(value).format('DD/MM/YYYY HH:mm');
					}
				},
				{
					key: 'isOnBoardingDocument',
					label: this.FormMSG(155, 'For onboarding'),
					sortable: true,
					class: 'text-center',
					formatter: (value) => {
						return value ? this.FormMSG(156, 'Yes') : this.FormMSG(157, 'No');
					}
				},
				{
					key: 'view',
					label: this.FormMSG(55, 'View'),
					sortable: false,
					formatter: (v) => v,
					class: 'text-center'
				},
				{
					key: 'rem',
					label: this.FormMSG(56, 'Delete'),
					sortable: false,
					formatter: (v) => v,
					class: 'text-center'
				}
			];
		},
		caption1() {
			return this.FormMSG(1, 'Document');
		},
		caption2() {
			return this.FormMSG(2, 'List of all documents');
		}
	},
	mounted() {
		if (this.$route.query.viaTabDocPackage) {
			this.activeTabDocPackage = true;
		}
	},
	methods: {
		async handleChangeShowArchivedDocument(payload) {
			this.hideArchived = payload;
			this.isBusyDataTable = true;
			await getDocumentList({ hideArchivedDocument: this.hideArchived }).then((result) => {
				this.docs = result;
				for (let i = 0; i < this.docs.length; i++) {
					this.docs[i].fullName = this.docs[i].publisher.name + ' ' + this.docs[i].publisher.firstName;
				}
				if (this.docs.length > 0) {
					this.curDoc = this.docs[0];
					this.newDoc = Object.assign({}, this.curDoc);
					this.firstTime = false;
				} else {
					this.initValuesForNoRecords();
				}
				this.isBusyDataTable = false;
			});
		},
		showBtnTrashByStatus({ item }) {
			return (
				(item.type !== 11 &&
					item.requireManagerApproval === false &&
					[DOCUMENT_DELIVERY_STATUS.NOT_PUBLISHED, DOCUMENT_DELIVERY_STATUS.NOT_RECEIVED, DOCUMENT_DELIVERY_STATUS.RECEIVED].includes(
						+item.status
					)) ||
				(item.type !== 11 && item.requireManagerApproval === true && item.hasBeenSigned === false) ||
				(item.type === 11 && item.archived === 0)
			);
		},
		viewDocument(item) {
			if (isNil(item)) return;

			const src = `${process.env.VUE_APP_GQL}/images/${item.xid}`;

			this.$previewImages({
				images: [
					{
						...item,
						src,
						fileName: item.fileName,
						xid: item.xid,
						ext: getFileExtension(item.xid)
					}
				],
				options: {
					presentationMode: 'doc',
					hideCommentButton: true,
					hideDisLikeButton: true,
					hideLikeDislike: true,
					hideCropButton: true,
					hideDeleteButton: true
				}
			});
		},
		showDocument() {
			// copy doc id in the store
			store.setCurrentDocumentId(this.newDoc.id);
			//console.log("item id:", item.id);
			const documentLink = `/documents/documentDetails/${this.newDoc.id.toString()} `;
			// console.log("starting:", documentLink);
			this.$router.push({
				path: documentLink,
				query: { isCreated: this.isCreated }
			});
		},
		initValuesForNoRecords() {
			this.newDoc.name = ' NEW DOCUMENT';
			this.newDoc.fileName = '';
			this.newDoc.type = parseInt('0', 10);
			this.newDoc.fileName = '';
			this.newDoc.userPassword = '';
			this.newDoc.ownerPassword = '';
			this.newDoc.xid = '';
			this.newDoc.useWatermark = false;
			this.newDoc.watermarkText = '';
			this.newDoc.watermarkPictureXid = '';
			this.newDoc.watermarkPictureFileName = '';
			this.newDoc.watermarkWithUser = false;
			this.newDoc.toSign = false;
			this.newDoc.toEmail = false;
			this.newDoc.toSms = false;
			this.newDoc.toWhatsApp = false;
			this.newDoc.availableOnline = true;
			this.newDoc.body = '';
		},
		async reloadData() {
			this.isBusyDataTable = true;
			const result = await getDocumentList({
				showDocumentOnBoardingPackage: false
			});
			if (result) {
				this.docs = result;
				for (let i = 0; i < this.docs.length; i++) {
					this.docs[i].fullName = this.docs[i].publisher.name + ' ' + this.docs[i].publisher.firstName;
					// this.docs[i].fileName = this.replaceToRightFileNameExt(this.docs[i].fileName, this.docs[i].docSignedXid);
				}
				// select element
				if (this.docs.length > 0) {
					this.curDoc = this.docs[0];
					this.newDoc = Object.assign({}, this.curDoc);
					this.firstTime = false;
				} else {
					//console.log("in reload data initValuesForNoRecords");
					this.initValuesForNoRecords();
				}
			}
			this.isBusyDataTable = false;
		},
		async delItem(id) {
			const action = async () => {
				const documentId = parseInt(id, 10);

				await deleteDocument(documentId)
					.then(async () => {
						await this.reloadData();
						this.successModalDelete = true;
					})
					.catch((error) => {
						this.documentWarningMessage = this.FormMSG(115, this.resolveGqlError(error, true));
						this.documentWarningModal = true;
					});
			};

			this.confirmModal(action, this.FormMSG(58, 'Are you sure to remove this document ?'));
		},
		rowClicked(item, index) {
			// open document window with doc selected
			// console.log("item in rowClicked  :", item);
			this.curDoc = item;
			this.newDoc = Object.assign({}, item);
			this.showDocument();

			return;
		},
		async createDocument() {
			this.isCreated = true;
			await newDocument()
				.then((result) => {
					// reload the Data
					// save new to newDoc
					this.newDoc = result;
					// open document window with doc selected
					this.showDocument();
				})
				.catch((err) => {
					console.log(err);
					this.erreur = err;
				});
		}
	},
	async created() {
		this.initTabs();
		await this.reloadData();
	}
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
	cursor: pointer;
}

input[type='texte'] {
	width: 100%;
	padding: 12px 20px;
	margin: 4px 0;
	box-sizing: border-box;
	border: none;
	background-color: white;
	color: white;
}
</style>
